const companyGroupQueryKeys = {
  all: [{ scope: 'companyGroup' }] as const,
  groups: () => [{ ...companyGroupQueryKeys.all[0], entity: 'group' }] as const,
  group: (context: { companyId?: string | null }) => [{ ...companyGroupQueryKeys.groups()[0], ...context }] as const
}

export default companyGroupQueryKeys
